import { createAction } from 'actions/utils'
import { apiAction } from 'actions/application'
import {
  duplicate,
  get,
  createFeatureRevision as createFeatureRevisionAction,
} from 'services/features'

export const LOAD_FEATURE_DATA = 'LOAD_FEATURE_DATA'
export const loadFeatureData = createAction(LOAD_FEATURE_DATA, [
  'featureId',
  'snapshotUri',
])

export const SET_IS_PRE_CREATE_NEW_FEATURE = 'SET_IS_PRE_CREATE_NEW_FEATURE'
export const setIsPreCreateFeature = createAction(SET_IS_PRE_CREATE_NEW_FEATURE)

export const SET_IS_FEATURE_MODAL_VIEW = 'SET_IS_FEATURE_MODAL_VIEW'
export const setIsModalViewForFeature = createAction(SET_IS_FEATURE_MODAL_VIEW)

export const RESET_FEATURE = 'RESET_FEATURE'
export const resetFeature = createAction(RESET_FEATURE)

export const FEATURE_SAVE_FAILED = 'FEATURE_SAVE_FAILED'
export const FEATURE_SAVED = 'FEATURE_SAVED'
export const OBSOLETE_FEATURE_SAVED = 'OBSOLETE_FEATURE_SAVED'

export const FEATURE_CREATE_FAILED = 'FEATURE_CREATE_FAILED'
export const FEATURE_CREATED = 'FEATURE_CREATED'

export const DUPLICATE_FEATURE_REQUEST = 'DUPLICATE_FEATURE_REQUEST'
export const DUPLICATE_FEATURE_SUCCESS = 'DUPLICATE_FEATURE_SUCCESS'
export const DUPLICATE_FEATURE_FAILURE = 'DUPLICATE_FEATURE_FAILURE'
export const duplicateFeature = (id, callback) =>
  apiAction({
    asyncFn: duplicate,
    args: { id },
    requestActionType: DUPLICATE_FEATURE_REQUEST,
    successActionType: DUPLICATE_FEATURE_SUCCESS,
    failureActionType: DUPLICATE_FEATURE_FAILURE,
    resolve: callback,
  })

export const SAVE_FEATURE = 'SAVE_FEATURE'
export const saveFeature = createAction(SAVE_FEATURE, ['callback'])

export const UPDATE_FEATURE = 'UPDATE_FEATURE'
export const updateFeature = createAction(UPDATE_FEATURE)

export const FEATURE_DATA_RECEIVED = 'FEATURE_DATA_RECEIVED'
export const FEATURE_DATA_REQUEST_FAILED = 'FEATURE_DATA_REQUEST_FAILED'

export const REQUESTING_FEATURE_DATA = 'REQUESTING_FEATURE_DATA'
export const getFeature = createAction(REQUESTING_FEATURE_DATA, ['featureId'])

export const GET_DONOR_FEATURE_DATA = 'GET_DONOR_FEATURE_DATA'
export const getDonorFeature = (featureId) =>
  apiAction({
    asyncFn: get,
    successActionType: GET_DONOR_FEATURE_DATA,
    args: { featureId },
  })

export const MERGE_DONOR_LOGIC = 'MERGE_DONOR_LOGIC'
export const mergeDonorLogic = createAction(MERGE_DONOR_LOGIC, [
  'currentFeatureId',
  'donorLogicMap',
  'donorFeatureId',
])

export const UPDATE_FEATURE_STATUS = 'UPDATE_FEATURE_STATUS'
export const updateFeatureStatus = createAction(UPDATE_FEATURE_STATUS, [
  'status',
  'previousStatus',
])

export const COMMIT_UPDATE_FEATURE_STATUS = 'COMMIT_UPDATE_FEATURE_STATUS'
export const commitUpdateFeatureStatus = createAction(
  COMMIT_UPDATE_FEATURE_STATUS,
  ['status', 'previousStatus', 'orphanQueryUris']
)

export const CREATE_NEW_FEATURE = 'CREATE_NEW_FEATURE'
export const createFeature = createAction(CREATE_NEW_FEATURE, [
  'callback',
  'onError',
])

export const PRE_CREATE_NEW_FEATURE = 'PRE_CREATE_NEW_FEATURE'
export const preCreateFeature = createAction(PRE_CREATE_NEW_FEATURE, [
  'moduleName',
])

export const RESET_PRE_CREATE_NEW_FEATURE = 'RESET_PRE_CREATE_NEW_FEATURE'
export const resetPreCreateNewFeature = createAction(
  RESET_PRE_CREATE_NEW_FEATURE
)

export const SET_SNAPSHOT_AS_CURRENT = 'SET_SNAPSHOT_AS_CURRENT'
export const setSnapshotAsCurrentFeature = createAction(
  SET_SNAPSHOT_AS_CURRENT,
  ['feature']
)

export const SET_FEATURE_AS_CURRENT = 'SET_FEATURE_AS_CURRENT'
export const setFeatureAsCurrentFeature = createAction(SET_FEATURE_AS_CURRENT, [
  'feature',
])

export const SET_FEATURE_IS_DIRTY = 'SET_FEATURE_IS_DIRTY'
export const setFeatureIsDirty = createAction(SET_FEATURE_IS_DIRTY, ['isDirty'])

export const CREATED_FEATURE_REVISION = 'CREATED_FEATURE_REVISION'
export const CREATE_FEATURE_REVISION_FAILED = 'CREATE_FEATURE_REVISION_FAILED'
export const CREATE_FEATURE_REVISION = 'CREATE_FEATURE_REVISION'
export const createFeatureRevision = (featureId) =>
  apiAction({
    asyncFn: createFeatureRevisionAction,
    args: { featureId },
    successActionType: CREATED_FEATURE_REVISION,
    failureActionType: CREATE_FEATURE_REVISION_FAILED,
  })
